import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { SendUserEventRequestType } from '../../../services/IbExternalServices/APIService/types';

import { useIbExternalServices } from '../useIbExternalServices';

interface UseSendUserEventApiInterface {
  sendUserEventApi: UseMutateAsyncFunction<
    void,
    Error,
    SendUserEventRequestType
  >;

  error: string | null;
  status: MutationStatus;
}

/**
 * Hook to send user event
 * @returns Interface with mutation function and status information
 */
const useSendUserEventApi = (): UseSendUserEventApiInterface => {
  const { ibExternalServicesInstance } = useIbExternalServices();

  const { mutateAsync, error, status } = useMutation(
    (requestObject: SendUserEventRequestType) =>
      ibExternalServicesInstance.sendUserEvent(requestObject),
    {
      mutationKey: ['sendUserEventApi']
    }
  );

  return {
    sendUserEventApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useSendUserEventApi };
